import { buildTeammateGroupFilterSearch } from "@repo/app-types/helpers/customerInteractionUrl";
import type { TeammateGroupReferenceWrapperProps } from "@repo/ui/structuredContent/teammateGroupReferenceContext";
import type { FC } from "react";
import { appPaths } from "../../app/appPaths.js";
import { usePlaybookIdParam } from "../../hooks/usePlaybookIdParam.js";
import { DEFAULT_PLAYBOOK_URL_SEGMENT } from "../links/defaultPlaybookRedirect.js";

/**
 * Links structured content teammate group references to the playbook's
 * teammates page filtered to the group, in a new tab like teammate references.
 * The link uses the playbook the reference resolved to, else the current
 * page's playbook, else the viewer's default playbook. Supplied to the shared
 * renderers via `TeammateGroupReferenceProvider`.
 */
export const TeammateGroupReferenceLinkAdapter: FC<
  TeammateGroupReferenceWrapperProps
> = (props) => {
  const { reference, className, children } = props;
  const pagePlaybookId = usePlaybookIdParam();
  const path = appPaths.playbookTeammates.build({
    playbookId:
      reference.playbookId ?? pagePlaybookId ?? DEFAULT_PLAYBOOK_URL_SEGMENT,
  });
  return (
    <a
      href={`${path}${buildTeammateGroupFilterSearch(reference.groupId)}`}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
    >
      {children}
    </a>
  );
};
